module.exports = __webpack_public_path__ + "static/Widevine-de340be57cf5c570484be76aa347caf2.png";